import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { RolesComponent } from '../roles/roles.component';
import { UserManagementViewService } from '../services/user-management-view.service';

@Component({
    selector: 'app-permits',
    templateUrl: './permits.component.html',
    styleUrls: ['./permits.component.scss'],
    standalone: false
})
export class PermitsComponent implements OnInit {
    //Default selected radio button
    public selectedRoleType: string = 'P';
    //Default selected tab
    public tabName = 'Empresa';

    constructor(
        private _dialog : MatDialog,
        public _viewService: UserManagementViewService) {}

    ngOnInit(): void {
        this._viewService.initManagementTabs();
        this._viewService.getTipoList();
    }

    public addNewRoles(): void {
        const modalRef = this._dialog.open(RolesComponent,{      
        });
        modalRef.afterClosed().subscribe(responce => {
          if (responce) { }
        });
      }
    

    public tabChanged(event: MatTabChangeEvent): any {
        this.tabName = event.tab.textLabel;
    }
}
